import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ChevronDownIcon, AddImageIcon } from '../../Svg/Index.js'
import { ADD_THREAD } from '../../Actions/Wazzup'
import Loader from '../../Components/Loader/Index.js'


class AddToGroup extends Component {

    state = {
        isPosting: false
    }

    componentDidMount() {
        this.refs.popup.classList.add('is-active');
    }

    handleAdd = () => {
        if(this.state.isPosting) return;
        let text = this.refs.message.value;
        let image = this.refs.image;
        this.setState({ isPosting: true })
        this.props.actions.ADD_THREAD(text, image, this.props.uuid).then(() => {
            window.scrollTo(0,0);
            this.props.closeSharePopup();
            this.props.refresh();
            this.setState({ isPosting: false })
        })
    }

    fileChange = (e) => {
        let image = this.refs.image;
        if (image.files && image.files[0]) {
            let reader = new FileReader();
            this.refs.messageImage.classList.add('is-uploading')
            reader.onload = (image)=> {
                this.refs.messageImage.style.backgroundImage = `url('${image.target.result}')`;
            }
            reader.readAsDataURL(image.files[0]);
        }
    }

    render() {
        const { closeSharePopup, author } = this.props;
        
        return (
            <>
                <div className="c-popup" ref="popup">
                    <div className="c-popup__inner">
                        {
                            this.state.isPosting && (
                                <Loader withClass="c-loader--alt c-loader--trans" />
                            )
                        }
                        <div className="c-popup__buttons">
                            <button className="c-btn c-btn--compact c-popup__close" onClick={closeSharePopup}><ChevronDownIcon /></button>
                            <button className="c-btn c-btn--compact" onClick={this.handleAdd}>Delen</button>
                        </div>
                        <span className="c-popup__title">Deel iets in deze groep</span>
                        <div className="c-popup__form">
                            <div className="c-popup__author">
                                <img src={author} alt=""/>
                            </div>
                            <div className="c-popup__fields">
                                <textarea className="c-form__textarea" name="message" rows="6" autoFocus placeholder="  Wat houdt je bezig?" ref="message"></textarea>
                                <input className="u-hidden" id="messageImage" type="file" accept="image/x-png,image/jpeg" name="image" ref="image" onChange={this.fileChange} />
                            </div>
                            
                        </div>
                        <label htmlFor="messageImage" className="c-form__add-file">
                            <span className="c-btn"><AddImageIcon /></span>
                            <span className="c-form__add-file__filename js-file-target" ref="messageImage"></span>
                        </label>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({ADD_THREAD}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToGroup)